import { ButtonSize, ButtonVariant } from '../../types/components';
import colors, { gradientValues } from '../../utils/colors';

export const HEIGHT_BY_SIZE: Record<ButtonSize, number> = {
  lg: 46,
  md: 39,
  sm: 31,
};

export const PADDING_HORIZONTAL_BY_SIZE: Record<ButtonSize, number> = {
  lg: 20,
  md: 17,
  sm: 17,
};

export const BORDER_RADIUS = 100;

export const BORDER_WIDTH = 1;

export type ButtonColors = {
  borderColor: string;
  iconColor: string;
  color: string;
  backgroundColors: {
    default: string[] | string;
    hover: string[] | string;
    active: string[] | string;
  };
  loadingSpinnerColor: string;
};

export const BUTTON_COLORS_BY_VARIANT: Record<ButtonVariant, ButtonColors> = {
  primary: {
    color: colors.white100,
    borderColor: colors.transparent,
    iconColor: colors.white100,
    backgroundColors: {
      default: gradientValues.colors.default,
      hover: gradientValues.colors.gradient110,
      active: gradientValues.colors.gradient120,
    },
    loadingSpinnerColor: colors.white100,
  },
  secondary: {
    color: colors.ink100,
    borderColor: colors.ink100,
    iconColor: colors.ink100,
    backgroundColors: {
      default: colors.transparent,
      hover: colors.ink10,
      active: colors.ink20,
    },
    loadingSpinnerColor: colors.ink100,
  },
  black: {
    color: colors.white100,
    borderColor: colors.transparent,
    iconColor: colors.white100,
    backgroundColors: {
      default: colors.ink100,
      hover: colors.ink110,
      active: colors.ink120,
    },
    loadingSpinnerColor: colors.white100,
  },
  white: {
    color: colors.ink100,
    borderColor: colors.transparent,
    iconColor: colors.ink100,
    backgroundColors: {
      default: colors.white100,
      hover: colors.ink10,
      active: colors.ink20,
    },
    loadingSpinnerColor: colors.ink100,
  },
};

export type ButtonConfig = {
  height: number;
  iconRightMargin: number;
  iconSize: number;
  paddingHorizontal: number;
  paddingHorizontalWithIcon: number;
};

export const BUTTON_CONFIG_BY_SIZE: Record<ButtonSize, ButtonConfig> = {
  lg: {
    height: 46,
    iconRightMargin: 10,
    iconSize: 22,
    paddingHorizontal: 20,
    paddingHorizontalWithIcon: 15,
  },
  md: {
    height: 39,
    iconRightMargin: 8,
    iconSize: 19,
    paddingHorizontal: 17,
    paddingHorizontalWithIcon: 13,
  },
  sm: {
    height: 31,
    iconRightMargin: 5,
    iconSize: 18,
    paddingHorizontal: 17,
    paddingHorizontalWithIcon: 9,
  },
};
